module.exports = __webpack_public_path__ + "static/img/s28.9f012a88.png";